export const getPageCount = (totalItemCount, itemPerPage) => {
  return Math.ceil(totalItemCount / itemPerPage);
};

export const getCurrentPageData = (data, pageSize, currentPage) => {
  return data.slice((currentPage - 1) * pageSize, currentPage * pageSize);
};
